import React from "react";
// import React, { useRef, useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Home from "./components/Home";
// import StockAnalyzer from "./components/StockAnalyzer";
import StockAnalyzer2 from "./components/StockAnalyzer2";
import KeyIndicators from "./components/KeyIndicators";
import Financials from "./components/Financials";
import Fundamentals from "./components/Fundamentals";
import IncomeStatement from "./components/IncomeStatement";
import BalanceSheet from "./components/BalanceSheet";
import CashFlow from "./components/CashFlow";
import FundamentalsSearch from "./components/FundamentalsSearch";
import FundamentalsSearchResults from "./components/FundamentalsSearchResults";
import { FundamentalsSelectionProvider } from "./components/FundamentalsSelectionContext";
import { createTheme, ThemeProvider } from "@mui/material/styles";
// import "./components/scrollbar.css";

const theme = createTheme({
	typography: {
		fontFamily:
			'Inter,-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif',
	},
	palette: {
		primary: {
			main: "#3a2206", // Replace with your desired color
		},
	},
});

function App() {
	// const headerRef = useRef(null);
	// const [headerHeight, setHeaderHeight] = useState(0);

	// // header height is 64px default and 59px for mobile
	// useEffect(() => {
	// 	if (headerRef.current) {
	// 		setHeaderHeight(headerRef.current.offsetHeight);
	// 	}
	// }, []);

	return (
		<ThemeProvider theme={theme}>
			<FundamentalsSelectionProvider>
				<Router>
					{/* header component always rendered */}
					<Header></Header>
					{/* <Header ref={headerRef} />
					{console.log("header height:", headerHeight)} */}
					<Routes>
						<Route path="/" element={<Home />} />
						<Route
							path="/fundamentals-search"
							element={<FundamentalsSearch />}
						/>
						<Route
							path="/fundamentals-search/results"
							element={<FundamentalsSearchResults />}
						/>
						{/* Parent route for StockAnalyzerTabs */}
						{/* <Route
							path="/stock-analyzer"
							element={<StockAnalyzer></StockAnalyzer>}
						> */}
						<Route
							path="/stock-analyzer/:symbol"
							element={<StockAnalyzer2></StockAnalyzer2>}
						>
							<Route
								path="key-indicators"
								element={<KeyIndicators />}
							/>
							<Route
								path="financials"
								element={<Financials></Financials>}
							>
								<Route
									path="income-statement"
									element={<IncomeStatement />}
								/>
								<Route
									path="balance-sheet"
									element={<BalanceSheet />}
								/>
								<Route
									path="cash-flow"
									element={<CashFlow />}
								/>
							</Route>
							<Route
								path="fundamentals"
								element={<Fundamentals />}
							/>
							<Route path="1" element={<></>} />
							<Route path="2" element={<></>} />
							<Route path="3" element={<></>} />
							<Route path="4" element={<></>} />
							<Route path="*" element={<></>} />
						</Route>
						{/* <Route
							path="/stock-analyzer/balance-sheet"
							element={<BalanceSheet />}
						/>
						<Route
							path="/stock-analyzer/cash-flow"
							element={<CashFlow />}
						/> */}
					</Routes>
				</Router>
			</FundamentalsSelectionProvider>
		</ThemeProvider>
	);
}

export default App;
